/**
 * All external / fact-like values live here and ship EMPTY on purpose.
 * The app must render and function with every value blank.
 * Fill each one ONLY with a real, written-approved value from the client.
 */

export const META_PIXEL_ID = '' // Meta Pixel ID provided by the client's ad account
export const LEAD_WEBHOOK_URL = '' // CRM / automation webhook that receives the lead payload (must return CORS headers)
export const CAPI_ENDPOINT = '' // Server endpoint that forwards events to Meta Conversions API
/**
 * Single shared WhatsApp line for Miami Car Queens, in international digits only.
 * Whoever is available answers. Every WhatsApp control on the page opens this number.
 * If it is ever split into one line per Queen, reintroduce a chooser before opening.
 */
export const WHATSAPP_MAIN = '17868371854'
export const INSTAGRAM_URL = '' // Official Instagram profile URL
/**
 * Absolute URL of the share image used by WhatsApp / Meta link previews (1200×630).
 * Empty until an approved photo exists — no og:image tag is rendered while it is blank,
 * which is better than a preview card pointing at a missing file.
 */
export const OG_IMAGE_URL = ''
export const PRIVACY_POLICY_URL = '' // Hosted privacy policy URL
export const TERMS_URL = '' // Hosted terms URL
export const DEALER_DISCLOSURE = '' // Legal disclosure line, rendered in footer only if non-empty

// Fill ONLY with a credential the person has confirmed in writing.
export const GABRIELA_SUBTITLE = ''
export const CHANIRA_SUBTITLE = ''

// Fill ONLY with an address the client has approved for public use.
// The FAQ location answer reads from this and says nothing extra if it is empty.
export const LOCATION_ADDRESS = ''

/**
 * ADVERTISED OFFER — the hero's attention hook.
 *
 * A monthly payment is a "triggering term" under TILA / Regulation Z. The moment a
 * figure like "$299/mo" appears, the same ad must also state the down payment, term,
 * APR, number of payments, and qualification conditions. Publishing the number without
 * them is non-compliant credit advertising, and the offer itself belongs to the
 * dealership — not to two salespeople.
 *
 * So the banner is BUILT, but it renders NOTHING until every field below is filled
 * from a written, dealer-approved, unexpired offer. Partial data renders nothing: an
 * amount without its terms is exactly the illegal case.
 *
 * While these are blank, the hero shows a no-figure hook instead, which is compliant
 * and still converts.
 *
 * Fill from the dealer's approved offer sheet, e.g.
 *   OFFER_PAYMENT = '299'      OFFER_TERM_MONTHS = '36'
 *   OFFER_MODEL = '2026 Kia Sportage LX'
 *   OFFER_DOWN_PAYMENT = '3,999'   OFFER_APR = '5.9'
 *   OFFER_EXPIRES = '2026-08-31'
 *   OFFER_DISCLOSURE = 'Lease...' (the dealer's full legal line, verbatim)
 */
export const OFFER_PAYMENT = '' // Monthly payment amount, digits only, no "$"

/**
 * PLACEHOLDER FIGURE — requested by the client, NOT verified against a dealer offer
 * sheet. Shown only as a small "from" figure in the hero hook's empty space, with a
 * pending note beside it. Replace with a real approved amount (and fill the OFFER_*
 * fields above) before removing the noindex tag or running paid traffic.
 */
export const TEASER_PAYMENT = '299'
export const OFFER_MODEL = '' // Exact year, model, and trim the offer applies to
export const OFFER_TERM_MONTHS = '' // Term in months
export const OFFER_DOWN_PAYMENT = '' // Cash due at signing
export const OFFER_APR = '' // APR as advertised
export const OFFER_EXPIRES = '' // Offer end date (YYYY-MM-DD)
export const OFFER_DISCLOSURE = '' // The dealership's full disclosure line, verbatim
